import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetMappingAssetTagsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.MappingAssetTagFilterInput>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  order?: Types.InputMaybe<Array<Types.MappingAssetTagSortInput> | Types.MappingAssetTagSortInput>;
}>;


export type GetMappingAssetTagsQuery = { mappingAssetTags?: Maybe<{ __typename?: 'MappingAssetTagCollectionSegment', totalCount: number, items?: Maybe<Array<{ __typename?: 'MappingAssetTag', id: string, assetId: string, assetTagId: string, assetTag: { __typename?: 'AssetTag', id: string, tagValue: string } }>> }> };


export const GetMappingAssetTagsDocument = gql`
    query getMappingAssetTags($where: MappingAssetTagFilterInput, $take: Int, $skip: Int, $order: [MappingAssetTagSortInput!]) {
  mappingAssetTags(where: $where, skip: $skip, take: $take, order: $order) {
    totalCount
    items {
      id
      assetId
      assetTagId
      assetTag {
        id
        tagValue
      }
    }
  }
}
    `;

/**
 * __useGetMappingAssetTagsQuery__
 *
 * To run a query within a React component, call `useGetMappingAssetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMappingAssetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMappingAssetTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetMappingAssetTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMappingAssetTagsQuery, GetMappingAssetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMappingAssetTagsQuery, GetMappingAssetTagsQueryVariables>(GetMappingAssetTagsDocument, options);
      }
export function useGetMappingAssetTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMappingAssetTagsQuery, GetMappingAssetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMappingAssetTagsQuery, GetMappingAssetTagsQueryVariables>(GetMappingAssetTagsDocument, options);
        }
export type GetMappingAssetTagsQueryHookResult = ReturnType<typeof useGetMappingAssetTagsQuery>;
export type GetMappingAssetTagsLazyQueryHookResult = ReturnType<typeof useGetMappingAssetTagsLazyQuery>;
export type GetMappingAssetTagsQueryResult = Apollo.QueryResult<GetMappingAssetTagsQuery, GetMappingAssetTagsQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
